export default __webpack_public_path__ + "static/media/headerCheck.84965070.svg";